var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertMonarch6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 3C45.3594 3 57 14.6407 57 29C57 43.3594 45.3594 55 31 55C16.6406 55 5 43.3594 5 29C5 14.6407 16.6406 3 31 3Z",
    stroke: "#E3000F",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34428 52.1639C2.34428 52.9984 2.49626 53.7269 2.80013 54.3482C3.10693 54.9665 3.55749 55.2839 4.15243 55.2998C4.82176 55.2998 5.27494 54.94 5.5096 54.2174C5.74694 53.4974 5.86414 52.6144 5.86414 51.5694C5.86414 49.9934 5.29349 49.2038 4.15243 49.2038C3.95776 49.2038 3.74947 49.2359 3.5284 49.3028L3.56278 48.8198C3.53892 48.8198 3.6588 48.7854 3.92293 48.7159C4.18413 48.6467 4.41628 48.6119 4.61882 48.6119C5.13882 48.6119 5.57881 48.7559 5.94161 49.0465C6.30148 49.3372 6.57094 49.7134 6.74707 50.1748C6.9228 50.6359 7.01879 51.1212 7.03239 51.6359C7.03239 52.3186 6.90695 52.9774 6.65641 53.6146C6.40841 54.2548 6.04294 54.7718 5.56828 55.1694C5.09081 55.5667 4.53374 55.7639 3.8988 55.7639C3.29374 55.7639 2.78682 55.6121 2.37642 55.3082C1.96296 55.0039 1.65907 54.6014 1.45907 54.1024C1.2588 53.6039 1.16016 53.06 1.16016 52.4678C1.16016 52.2547 1.16546 52.0948 1.17639 51.9878C1.36572 50.3932 1.76561 49.0919 2.37374 48.0892C2.98147 47.0866 3.6376 46.3534 4.3444 45.8839C5.0508 45.4175 5.66949 45.1132 6.20549 44.9692C6.74135 44.8279 7.1068 44.7587 7.3068 44.7587L7.36841 45.2999C7.18961 45.2999 6.87216 45.3642 6.41642 45.4894C5.96282 45.6174 5.43747 45.9028 4.83761 46.3454C4.24014 46.7906 3.69882 47.4894 3.21362 48.4415C2.72829 49.3932 2.43761 50.6359 2.34428 52.1639Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8112 45.9384C12.9296 45.9384 13.8363 46.9498 13.8363 48.197C13.8363 49.4446 12.9296 50.4557 11.8112 50.4557C10.6929 50.4557 9.78613 49.4446 9.78613 48.197C9.78613 46.9498 10.6929 45.9384 11.8112 45.9384Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8112 45.9384C12.9296 45.9384 13.8363 46.9498 13.8363 48.197C13.8363 49.4446 12.9296 50.4557 11.8112 50.4557C10.6929 50.4557 9.78613 49.4446 9.78613 48.197C9.78613 46.9498 10.6929 45.9384 11.8112 45.9384Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8892 54.1943H7.76123C7.76123 52.0438 9.60951 50.2999 11.8892 50.2999C14.1691 50.2999 16.0173 52.0438 16.0173 54.1943H11.8892Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8892 54.1943H7.76123C7.76123 52.0438 9.60951 50.2999 11.8892 50.2999C14.1691 50.2999 16.0173 52.0438 16.0173 54.1943H11.8892Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1211 13L38.6815 16.5786L45.2424 20.1569L38.6814 24.2358L32.1814 27.7358L25.5605 23.7358L19 20L25.5605 16.5786L32.1211 13Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5404 34.6996L19.3606 27.468L19.1814 20.2358L25.6814 23.7358L32.1812 27.7358V34.7358V42.2358L25.8609 38.4677L19.5404 34.6996Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1814 27.7358L38.8609 24.0039L45.1814 20.2358L45.0018 27.4681L44.8224 34.7001L38.5019 38.4677L32.1814 42.2358V35.2358V27.7358Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-654 -908)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertMonarch6);
export default __webpack_public_path__ + "static/media/convert_monarch6.43f890b4f9cfba2f02b076f0fa44a880.svg";
export { ForwardRef as ReactComponent };